module.exports = __webpack_public_path__ + "static/media/7.927d7287.png";